import { JOB_EVENTS } from '../../constants/events';


const job = {
  isJobViewSaved: false
};

const jobReducer = (state = job, actions) => {
	switch (actions.type) {
		case JOB_EVENTS.UPDATE_JOB :
			state = Object.assign({}, state, actions.payload);
			break;
		case JOB_EVENTS.UPDATE_NEW_JOB :
			state = actions.payload;
			state.callUnlockShowHide = 0; // hide call button by default
			break;
		case JOB_EVENTS.UPDATE_RSA_DATA :
			state.rsaData = actions.payload;
			break;
		default:
			return state;
	}
	return state;
};


export default jobReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/JobReducer/index.js